import React from 'react';
import { Check } from 'lucide-react';
import { developmentCycle } from '../../data/developmentDomains';
import type { DevStage } from '../../types/developmentDemo';
const activeIndex: Record<DevStage, number> = {
  'ready-initial': 0,
  'awaiting-review': 1,
  revision: 0,
  'awaiting-activity': 2,
  practising: 2,
  'ready-reassessment': 3,
  'cycle-complete': 4
};
export function CycleStrip({
  stage
}: {
  stage: DevStage;
}) {
  const current = activeIndex[stage];
  return <ol aria-label="Human Capability Framework cycle" className="grid grid-cols-2 gap-2 sm:grid-cols-4" data-id="element-551" data-mp="2nivrgb14073s">
      {developmentCycle.map((step, index) => {
      const done = index < current;
      const active = index === current;
      return <li key={step} aria-current={active ? 'step' : undefined} className={`flex items-center gap-2 rounded-lg border px-3 py-2.5 text-sm font-semibold ${active ? 'border-navy bg-navy text-white' : done ? 'border-teal/30 bg-teal-pale text-navy' : 'border-line bg-white text-ink-muted'}`} data-id="element-552" data-mp="2drho1s61en5d" data-mpi={index}>
            <span aria-hidden="true" className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs ${active ? 'bg-white/15' : done ? 'bg-teal text-white' : 'bg-surface-muted'}`} data-id="element-553" data-mp="wvkbzrc63j8j">
              {done ? <Check size={13} data-id="element-554" data-mp="1kk3jw5rb1u03" /> : index + 1}
            </span>
            {step}
            <span className="sr-only" data-id="element-555" data-mp="1km6lln1tlbkn">{done ? ' (done)' : active ? ' (current)' : ''}</span>
          </li>;
    })}
    </ol>;
}